<template>
  <ProSpaceGeoLayout v-if="model" class="adjustment-item-archive">
    <template #top>
      <ProSpaceTopPanel :header="layoutName" back @back="backHandler" />
    </template>
    <template #center>
      <ProSpaceGeoLayout
        :is-templated="true"
        :template-center="true"
        :template-right="true"
      >
        <template #center>
          <ProSpaceTabs
            v-model="modelTab"
            :tabs="tabs"
            :loading="loading"
            style="row-gap: 15px;"
          >
            <template v-slot:tab-1>
              <ProSpaceMainGrid
                ref="grid"
                class="adjustment-item-archive__view-adjustment"
                :cleanRecords="getAdjustmentEditedFields"
                localSort
                selectionMode="none"
                defaultSortField="name"
                dataKey="key"
              >
                <template #columns>
                  <Column
                    class="adjustment-item-archive__status-cell"
                    :style="checkAccessAcceptance || checkAccessApproval
                      ?
                      'min-width: 150px; flex: 0 1 calc(100% - ((155px * 2) + (230px * 2))) !important;'
                      :
                      'min-width: 150px !important;'
                    "
                    field="name"
                    :header="$t('adjustmentEditedFields')"
                    sortable
                  >
                    <template #body="field">
                      <ProSpaceTableHeaderCell
                        v-if="field.data"
                        noHover
                        :title="field.data.name"
                        align-items="center"
                        :tagBigText="false"
                      />
                    </template>
                  </Column>

                  <Column
                    :header="$t('adjustmentsCurrentValue')"
                    style="
                      max-width: 155px !important;
                      flex: 0 0 155px !important;
                    "
                  >
                    <template #body="{ data }">
                      <ProSpaceTextBlock
                        class="adjustment-item-archive__values"
                        type="secondary"
                        :gap="2"
                        :top="$t('adjustmentOldValue')"
                        :title="getFieldOldValue(data)"
                        :bottom="getFieldOldValue(data)"
                      />
                    </template>
                  </Column>

                  <Column
                    :header="$t('adjustmentsNewValue')"
                    style="
                      max-width: 155px !important;
                      flex: 0 0 155px !important;
                    "
                  >
                    <template #body="{ data }">
                      <ProSpaceTextBlock
                        class="adjustment-item-archive__values"
                        type="secondary"
                        :gap="2"
                        :top="$t('adjustmentNewValue')"
                        :title="getFieldNewValue(data)"
                        :bottom="getFieldNewValue(data)"
                      />
                    </template>
                  </Column>

                  <Column
                    :header="$t('acceptance')"
                    class="adjustment-item-archive__acceptance-cell"
                    :style="checkAccessAcceptance
                      ?
                      'flex: 1 0 230px; max-width: 230px !important;'
                      : 'flex: 1 0 130px; max-width: 130px !important;'
                    "
                  >
                    <template #body="field">
                      <ProSpaceHLayout :gap="10">
                        <ProSpaceSelectButton
                          v-if="checkAccessAcceptance"
                          class="adjustments-grid__select-btn"
                          v-model="editedFields.find(i => i.key === field.data.key)['acceptanceStatus']"
                          :items="[
                            {value: 'false', label: this.$t('adjustmentBlockDecline'), icon: 'close'},
                            {value: 'true', label: this.$t('adjustmentBlockAccept'), icon: 'check'}
                          ]"
                        />
                        <ProSpaceTag
                          :type="field.data?.acceptanceStatus ? 'success' : 'error'"
                          :text="field.data?.acceptanceStatus ? $t('adjustmentFieldAccepted') : $t('adjustmentFieldDeclined')"
                          v-else-if="model.status !== 'onacceptance' && field.data?.acceptanceStatus !== null"
                        />
                      </ProSpaceHLayout>
                    </template>
                  </Column>

                  <Column
                    :header="$t('approval')"
                    class="adjustment-item-archive__acceptance-cell"
                    :style="checkAccessApproval
                      ?
                        'flex: 1 0 230px; max-width: 230px !important;'
                      :
                        'flex: 1 0 130px; max-width: 130px !important;'
                    "
                  >
                    <template #body="field">
                      <ProSpaceHLayout :gap="10">
                        <ProSpaceSelectButton
                          v-if="checkAccessApproval"
                          class="adjustments-grid__select-btn"
                          v-model="editedFields.find(i => i.key === field.data.key)['approvalStatus']"
                          :items="[
                            {value: 'false', label: this.$t('adjustmentBlockDecline'), icon: 'close'},
                            {value: 'true', label: this.$t('adjustmentBlockAccept'), icon: 'check'}
                          ]"
                        />
                        <ProSpaceTag
                          v-else-if="model.status !== 'onapproval' && field.data?.approvalStatus !== null"
                          :type="field.data?.approvalStatus ? 'success' : 'error'"
                          :text="field.data?.approvalStatus ? $t('adjustmentFieldAccepted') : $t('adjustmentFieldDeclined')"
                        />
                      </ProSpaceHLayout>
                    </template>
                  </Column>

                </template>
                <template #empty>
                  <ProSpaceEmptyGrid
                    icon="error-message"
                    :title="$t('noDataTitle')"
                    :text="$t('noDataTxt')"
                  />
                </template>
              </ProSpaceMainGrid>
              <ProSpaceModal
                v-model="adjustmentCommentModalShow"
                icon="plus"
                :key="`adjustment-сomment-${adjustmentCommentModalShow}`"
                :title="$t('adjustmentComment')"
                :width="405"
                :cancelTxt="$t('cancelTxt')"
                :applyTxt="$t('adjustmentCommentSend')"
                :validate-local="$t"
                :validate-model="adjustmentCommentModel"
                :validate-config="{
                  comment: {
                    required
                  }
                }"
                @apply="addComment"
              >
                <template #default="{ v }">
                  <ProSpaceVLayout :gap="0">
                    <ProSpaceInputText
                      :label="$t('adjustmentComment')"
                      v-model="adjustmentCommentModel.comment"
                      :placeholder="$t('adjustmentComment')"
                      :invalid="v.comment.$error"
                      :invalid-messages="v.comment.$errors"
                      isTextarea
                      :rows="3"
                      @blur="v.comment.$touch"
                    />
                  </ProSpaceVLayout>
                </template>
              </ProSpaceModal>
              <ProSpaceTabs
                v-model="modelTab1"
                :tabs="tabs1"
                :loading="loading"
                style="row-gap: 15px; margin-top: 20px;"
              >
                <template v-slot:tab-1>
                  <ProSpaceVLayout class="adjustments-params__rows adjustments-params__rows--details">
                    <ProSpaceGeoLayout
                      class="geo-row"
                      isHideBottom
                      isHideTop
                      isHideRight
                      :gap="60"
                    >
                      <template v-slot:left>
                        <ProSpaceTextBlock
                          class="adjustments-params__left-block"
                          :top="$t('addressProgramAgencyParamsInfo')"
                          :bottom="$t('addressProgramAgencyParamsDescription')"
                          :gap="10"
                          break-word
                        />
                      </template>
                      <template v-slot:center>
                        <ProSpaceVLayout :gap="20">
                          <ProSpaceHLayout
                            justify-content="flex-start"
                            align-items="flex-start"
                            :gap="20"
                          >
                            <ProSpaceVLayout :gap="10">
                              <ProSpaceTextBlock
                                :top="$t('agency')"
                                :bottom="model.agencyValue"
                                :gap="10"
                                break-word
                              />
                            </ProSpaceVLayout>
                            <ProSpaceVLayout :gap="10">
                              <ProSpaceTextBlock
                                :top="$t('network')"
                                :bottom="model.networkValue"
                                :gap="10"
                                break-word
                              />
                            </ProSpaceVLayout>
                            <ProSpaceVLayout :gap="10">
                              <ProSpaceTextBlock
                                :top="$t('address')"
                                :bottom="model.address"
                                :gap="10"
                                break-word
                              />
                            </ProSpaceVLayout>
                          </ProSpaceHLayout>
                          <ProSpaceHLayout
                            justify-content="flex-start"
                            align-items="flex-start"
                            :gap="20"
                          >
                            <ProSpaceVLayout :gap="10">
                              <ProSpaceTextBlock
                                :top="$t('externalCode')"
                                :bottom="model.externalCode"
                                :gap="10"
                                break-word
                              />
                            </ProSpaceVLayout>
                            <ProSpaceVLayout :gap="10">
                              <ProSpaceTextBlock
                                :top="$t('kae')"
                                :bottom="model.kaeValue"
                                :gap="10"
                                break-word
                              />
                            </ProSpaceVLayout>
                            <ProSpaceVLayout :gap="10">
                              <ProSpaceTextBlock
                                :top="$t('kAS')"
                                :bottom="model.kasValue"
                                :gap="10"
                                break-word
                              />
                            </ProSpaceVLayout>
                          </ProSpaceHLayout>
                        </ProSpaceVLayout>
                      </template>
                    </ProSpaceGeoLayout>
                  </ProSpaceVLayout>
                </template>
              </ProSpaceTabs>
            </template>
            <template v-slot:tab-2>
              <ProSpaceVLayout class="adjustments-params__rows">
                <ProSpaceGeoLayout
                  class="geo-row"
                  isHideBottom
                  isHideTop
                  isHideRight
                  :gap="60"
                >
                  <template v-slot:left>
                    <ProSpaceTextBlock
                      class="adjustments-params__left-block"
                      :top="$t('addressProgramOutletInfo')"
                      :bottom="$t('addressProgramOutletDescription')"
                      :gap="10"
                      break-word
                    />
                  </template>
                  <template v-slot:center>
                    <ProSpaceHLayout
                      justify-content="flex-start"
                      align-items="flex-start"
                      :gap="20"
                    >
                      <ProSpaceVLayout :gap="10">
                        <ProSpaceTextBlock
                          :top="$t('network')"
                          :bottom="outletData.networkValue"
                          :gap="10"
                          break-word
                        />
                      </ProSpaceVLayout>
                      <ProSpaceVLayout :gap="10">
                        <ProSpaceTextBlock
                          :top="$t('address')"
                          :bottom="outletData.address"
                          :gap="10"
                          break-word
                        />
                      </ProSpaceVLayout>
                      <ProSpaceVLayout :gap="10">
                        <ProSpaceTextBlock
                          :top="$t('coverage')"
                          :bottom="outletData.coverage ? $t('yes') : $t('no')"
                          :gap="10"
                          break-word
                        />
                      </ProSpaceVLayout>
                    </ProSpaceHLayout>
                  </template>
                </ProSpaceGeoLayout>
                <ProSpaceGeoLayout
                  class="geo-row"
                  isHideBottom
                  isHideTop
                  isHideRight
                  :gap="60"
                >
                  <template v-slot:left>
                    <ProSpaceTextBlock
                      class="adjustments-params__left-block"
                      :top="$t('addressProgramGeoPointInfo')"
                      :bottom="$t('addressProgramGeoPointDescription')"
                      :gap="10"
                      break-word
                    />
                  </template>
                  <template v-slot:center>
                    <ProSpaceVLayout :gap="20">
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('area')"
                            :bottom="outletData.area"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('city')"
                            :bottom="outletData.city"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('geoCluster')"
                            :bottom="outletData.clusterValue"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                      </ProSpaceHLayout>
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('rsm')"
                            :bottom="outletData.rsmValue"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('tdm')"
                            :bottom="outletData.tdmValue"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('kae')"
                            :bottom="outletData.kaeValue"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                      </ProSpaceHLayout>
                    </ProSpaceVLayout>
                  </template>
                </ProSpaceGeoLayout>
                <ProSpaceGeoLayout
                  class="geo-row"
                  isHideBottom
                  isHideTop
                  isHideRight
                  :gap="60"
                >
                  <template v-slot:left>
                    <ProSpaceTextBlock
                      class="adjustments-params__left-block"
                      :top="$t('addressProgramClassifiersParamsInfo')"
                      :bottom="$t('addressProgramClassifiersParamsDescription')"
                      :gap="10"
                      break-word
                    />
                  </template>
                  <template v-slot:center>
                    <ProSpaceVLayout :gap="20">
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('externalFormat')"
                            :bottom="outletData.externalFormatValue"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('outletType')"
                            :bottom="outletData.outletTypeValue"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('channel')"
                            :bottom="outletData.channelValue"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                      </ProSpaceHLayout>
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('narka')"
                            :bottom="outletData.narkaValue"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('sIPChannel')"
                            :bottom="outletData.sipChannelValue"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('addressProgramOrderTerritoryCluster')"
                            :bottom="outletData.territoryCluster"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                      </ProSpaceHLayout>
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                        style="margin-top: 10px;"
                      >
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('externalCode')"
                            :bottom="outletData.externalCode"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('tariffZone')"
                            :bottom="outletData.tariffZone"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('skyline')"
                            :bottom="outletData.skyline"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                      </ProSpaceHLayout>
                    </ProSpaceVLayout>
                  </template>
                </ProSpaceGeoLayout>
                <ProSpaceGeoLayout
                  class="geo-row"
                  isHideBottom
                  isHideTop
                  isHideRight
                  :gap="60"
                >
                  <template v-slot:left>
                    <ProSpaceTextBlock
                      class="adjustments-params__left-block"
                      :top="$t('addressProgramAgencyParamsInfo')"
                      :bottom="$t('addressProgramAgencyParamsDescription')"
                      :gap="10"
                      break-word
                    />
                  </template>
                  <template v-slot:center>
                    <ProSpaceVLayout :gap="20">
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('agency')"
                            :bottom="outletData.agencyValue"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                      </ProSpaceHLayout>
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('kAS')"
                            :bottom="outletData.kasValue"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('merchandiser')"
                            :bottom="outletData.merchandiserValue"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('routeCode')"
                            :bottom="outletData.routeCodeValue"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                      </ProSpaceHLayout>
                    </ProSpaceVLayout>
                  </template>
                </ProSpaceGeoLayout>
                <ProSpaceGeoLayout
                  class="geo-row"
                  isHideBottom
                  isHideTop
                  isHideRight
                >
                  <template v-slot:left>
                    <ProSpaceTextBlock
                      class="adjustments-params__left-block"
                      :top="$t('addressProgramKPIInfo')"
                      :bottom="$t('addressProgramKPIDescription')"
                      :gap="10"
                      break-word
                    />
                  </template>
                  <template v-slot:center>
                    <ProSpaceVLayout :gap="20">
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('visitSum')"
                            :bottom="formatDigit(outletData.frequencyPlan, null, 0)"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('addressProgramOrderTimingPerVisit')"
                            :bottom="formatDigit(outletData.timingPerVisitPlan)"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('fteMerch')"
                            :bottom="formatDigit(outletData.fteMerchPlan)"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                      </ProSpaceHLayout>
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('osa')"
                            :bottom="getKpiValue(outletData.osaPlan)"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('isaOsa')"
                            :bottom="getKpiValue(outletData.deltaISAOSAPlan)"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('pss')"
                            :bottom="getKpiValue(outletData.pssPlan)"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                      </ProSpaceHLayout>
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('addressProgramOrderTotalSum')"
                            :bottom="formatDigit(outletData.totalSumPlan)"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                      </ProSpaceHLayout>
                    </ProSpaceVLayout>
                  </template>
                </ProSpaceGeoLayout>
                <ProSpaceGeoLayout
                  class="geo-row"
                  isHideBottom
                  isHideTop
                  isHideRight
                  :gap="60"
                >
                  <template v-slot:left>
                    <ProSpaceTextBlock
                      class="adjustments-params__left-block"
                      :top="$t('addressProgramBudgetInfo')"
                      :bottom="$t('addressProgramBudgetDescription')"
                      :gap="10"
                      break-word
                    />
                  </template>
                  <template v-slot:center>
                    <ProSpaceVLayout :gap="20">
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('tacticalTask')"
                            :bottom="formatDigit(outletData.tacticalTaskPlan)"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('addressProgramOrderRatePerHour')"
                            :bottom="formatDigit(outletData.ratePerHourPlan)"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('addressProgramOrderVisitSum')"
                            :bottom="formatDigit(outletData.visitSumPlan)"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                      </ProSpaceHLayout>
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('addressProgramOrderOsaSum')"
                            :bottom="formatDigit(outletData.osaSumPlan)"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('addressProgramOrderDeltaISAOSASum')"
                            :bottom="formatDigit(outletData.deltaISAOSASumPlan)"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('addressProgramOrderPssSum')"
                            :bottom="formatDigit(outletData.pssSumPlan)"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                      </ProSpaceHLayout>
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceVLayout :gap="10">
                          <ProSpaceTextBlock
                            :top="$t('addressProgramOrderTacticalTaskSum')"
                            :bottom="formatDigit(outletData.tacticalTaskSumPlan)"
                            :gap="10"
                            break-word
                          />
                        </ProSpaceVLayout>
                      </ProSpaceHLayout>
                    </ProSpaceVLayout>
                  </template>
                </ProSpaceGeoLayout>
              </ProSpaceVLayout>
            </template>
          </ProSpaceTabs>
        </template>
        <template #right>
          <AdjustmentFormPanel
            ref="formPanel"
            :adjustment="model"
            :isAdjustmentTab="true"
            :isProceeded="isProceeded"
            :periodId="currentPeriod.id"
          />
        </template>
      </ProSpaceGeoLayout>
    </template>
  </ProSpaceGeoLayout>
</template>
<script>
import {
  ProSpaceTopPanel,
  ProSpaceInputText,
  ProSpaceAction,
  ProSpaceRadioButtonSecondary,
  ProSpaceGeoLayout,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpaceTextBlock,
  ProSpaceHLayout,
  ProSpaceVLayout,
  ProSpaceDropdown,
  ProSpaceFile,
  ProSpaceInputCalendar,
  ProSpaceInputNumber,
  ProSpaceSearchfield,
  ProSpaceMultiSelect,
  ProSpaceIcon,
  ProSpaceMainGrid,
  ProSpaceDots,
  ProSpaceTableHeaderCell,
  ProSpaceEmptyGrid,
  ProSpaceFlashMessage,
  ProSpaceModal,
  ProSpaceSelectButton,
  ProSpaceTag
} from "@prospace/prospace-components-library";
import Column from "primevue/column";
import AdjustmentFormPanel from "./components/AdjustmentFormPanel";
import { AdjustmentService } from "../../services/AdjustmentService.js";
import { AdjustmentCommentService } from "../../services/AdjustmentCommentService";
import { mapGetters } from "vuex";
import accessMixin from "../../../../../Frontends/Common/utils/elementAccess/accessMixin";
import { AddressProgramOrderService } from "../../services/AddressProgramOrderService"
import formatDigit from "@prospace/prospace-components-library/src/lib-assets/mixins/digitFormatter";

export default {
  mixins: [accessMixin],
  components: {
    ProSpaceTopPanel,
    ProSpaceGeoLayout,
    ProSpaceInputText,
    ProSpaceAction,
    ProSpaceRadioButtonSecondary,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpaceTextBlock,
    ProSpaceHLayout,
    ProSpaceVLayout,
    ProSpaceDropdown,
    ProSpaceFile,
    ProSpaceInputCalendar,
    ProSpaceInputNumber,
    ProSpaceSearchfield,
    ProSpaceMultiSelect,
    ProSpaceIcon,
    ProSpaceMainGrid,
    ProSpaceDots,
    ProSpaceTableHeaderCell,
    ProSpaceEmptyGrid,
    ProSpaceFlashMessage,
    ProSpaceModal,
    Column,
    ProSpaceSelectButton,
    AdjustmentFormPanel,
    ProSpaceTag
  },
  data() {
    return {
      currentStatus: 'approvalStatus',
      // Tabs
      modelTab: {
        name: this.$t("adjustmentRequest"),
        isActive: true,
        systemName: "adjustmentRequest",
      },
      modelTab1: {},

      // Common
      layoutName: "",
      model: null,
      editedFields: [],
      loading: false,
      skipCheckChanges: false,

      //Comments
      adjustmentCommentModalShow: false,
      adjustmentCommentModel: {
        comment: "",
        role: null,
        adjustmentId: null
      },
      
      // Service
      adjustmentService: new AdjustmentService(),
      adjustmentCommentService: new AdjustmentCommentService(),
      addressProgramOrderService: new AddressProgramOrderService(),

      getMethod: "get",
      masterId: null,
      addressProgramId: null,
      outletData: {},
      percentageKeys: ['osaPlan', 'pssPlan'],
      formattingKeys: [
        "ratePerHourPlan", "ratePerHourFact", "timingPerVisitPlan",
        "timingPerVisitFact", "fteMerchPlan", "fteMerchFact",
        "osaPlan", "osaFact", "pssPlan",
        "pssFact", "tacticalTaskPlan", "tacticalTaskFact",
        "visitSumPlan", "osaSumPlan", "pssSumPlan",
        "tacticalTaskSumPlan", "totalSumPlan", "visitSumFact",
        "osaSumFact", "pssSumFact", "tacticalTaskSumFact",
        "totalSumFact", "osaTargetPlanW", "osaTargetFactW",
        "osaReportPlanW", "osaReportFactW",
      ]
    };
  },
  watch: {
    modelTab(val) {
      if (val && val.systemName === 'adjustmentRequest') {
        setTimeout(() => {
          this.$refs.grid.loading = false;
        }, 500);
      }
    }
  },
  watch: {
    modelTab(val) {
      if (val && val.systemName === 'adjustmentRequest') {
        setTimeout(() => {
          this.$refs.grid.loading = false;
        }, 500);
      }
    }
  },
  mounted() {
    this.loadRoleAccess();
    this.getData();
    window.addEventListener("beforeunload", this.beforeUnload);
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this.beforeUnload);
  },
  beforeRouteLeave(to, from) {
    if(this.checkAdjustmentChanges()) {
      this.skipCheckChanges = true;
      this.showConfirmUnsavedChanges(
        () => { this.$router.push({ name: to.name }) },
        () => {
          this.$parent.$parent.$parent.setActiveMenuitem(from);
          this.skipCheckChanges = false;
        }
      );
      return false;
    }

    return true;
  },
  methods: {
    formatDigit,
    getKpiValue(value) {
      if (!value) {
        return ''
      }
      if (!isNaN(value) && value.toString().includes('.')) {
        value = parseFloat((parseFloat(value) * 100).toFixed(2));
        value = formatDigit(value) + '%';
      }
      return value;
    },
    beforeUnload(event) {
      if(this.checkAdjustmentChanges()) {
        event.returnValue = "";
        event.preventDefault();
      }
    },
    setTitle(title) {
      if(this.isGrouped) {
        title
          ? this.layoutName += `${title} | ${this.$t("adjustmentRequestGrouped")}`
          : this.$t("adjustmentRequestGrouped");
      } else {
        title
          ? this.layoutName += `${title} | ${this.$t("adjustmentRequest")}`
          : this.$t("adjustmentRequest");
      }
    },
    async getData() {
      this.masterId = this.$route.params.id;
      let title = this.$route.params.agencyValue;
      if (this.masterId === undefined) {
        // redirect to 404
        return;
      }
      this.setTitle(title);
      const result = await this.adjustmentService[this.getMethod](
        this.masterId, this.currentPeriod.id
      );
      this.editedFields = JSON.parse(result.data.editedFieldsConfig);
      this.adjustmentService.editedFields = this.editedFields;
      this.model = result.data;
      if (!title) {
        this.setTitle(this.model.agencyValue);
      }
      if (this.model.status === 'onacceptance') {
        this.currentStatus = 'acceptanceStatus'
      } else if (this.model.status === 'onapproval') {
        this.currentStatus = 'approvalStatus'
      }

      const request = await this.addressProgramOrderService[this.getMethod](result.data.addressProgramOrderId);
      this.outletData = request.data
      this.$refs.grid.loading = false;
    },
    backHandler() {
      if(this.checkAdjustmentChanges()) {
        this.skipCheckChanges = true;
        this.showConfirmUnsavedChanges(
          () => { this.back() },
          () => { this.skipCheckChanges = false }
        );
      } else {
        this.back();
      }
    },
    back() {
      this.$router.go(-1);
    },
    getStatus(status) {
      if (!status) return;

      let type = "default";
      switch (status) {
        case "adjustmentFieldRequested":
          type = "default";
          break;
        case "adjustmentFieldAccepted":
          type = "teal";
          break;
        case "adjustmentFieldDeclined":
          type = "danger";
          break;
      }

      return {
        type: type,
        text: this.$t(status),
      };
    },
    checkAdjustmentChanges() {
      if(this.skipCheckChanges)
        return false;

      let prevValues = JSON.parse(this.model.editedFieldsConfig);

      return this.editedFields.some(x => prevValues.find(f => f.key === x.key).status !== x.status);
    },
    selectAddressProgram(addressProgram) {
      this.addressProgramId = addressProgram.id;
    },
    showAdjustmentCommentModal() {
      this.adjustmentCommentModel.comment = "";
      this.adjustmentCommentModel.role = JSON.parse(localStorage.getItem("userRole")).displayName;
      this.adjustmentCommentModalShow = true;
    },
    addComment() {
      this.loading = true
      let commentsToAdd = [Object.assign(_.cloneDeep(this.adjustmentCommentModel), { adjustmentId: this.model.id })];

      this.adjustmentCommentService.createMany(commentsToAdd, this.currentPeriod.id).then(() => {
        this.$refs.formPanel.getComments();
        this.declineAll();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
    },
    getFieldOldValue(data) {
      if (!data) return null;
      let value = data.oldDisplayValue || data.oldValue;
      if (data?.key == 'coverage') {
        value = this.$t(`coverage_${data.oldValue.toString().toLowerCase()}`);
      }
      if (!isNaN(value) && String(value).includes('.')) {
        value = parseFloat(value).toFixed(2);
      }
      if (this.formattingKeys.includes(data.key)) {
        value = formatDigit(value);
      }
      if (!isNaN(value) && this.percentageKeys.includes(data.key)) {
        value += '%';
      }
      return value;
    },
    getFieldNewValue(data) {
      if (!data) return null;
      let value = data.displayValue || data.newValue;
      if (data?.key == 'coverage') {
        value = this.$t(`coverage_${data.newValue}`);
      }
      if (!isNaN(value) && String(value).includes('.')) {
        value = parseFloat(value).toFixed(2);
      }
      if (this.formattingKeys.includes(data.key)) {
        value = formatDigit(value);
      }
      if (!isNaN(value) && this.percentageKeys.includes(data.key)) {
        value += '%';
      }
      return value;
    }
  },
  computed: {
    ...mapGetters({
      access: "securityRoleAccess/access",
      currentPeriod: "marsPeriodStoreArchived/getMarsPeriod"
    }),
    checkAccessApproval() {
      return this.checkAccess('adjustment-approval') && this.model.status === 'onapproval';
    },
    checkAccessAcceptance() {
      return this.checkAccess('adjustment-acceptance') && this.model.status === 'onacceptance';
    },
    showDotsInPanel() {
      if (this.model?.status === 'completed') return false
      if (this.model?.status === 'onacceptance' && this.checkAccess('adjustment-acceptance')) return true
      else if (this.model?.status === 'onapproval' && this.checkAccess('adjustment-approval')) return true
    },
    isSaveDisabled() {
      return this.model.status === 'completed' || this.editedFields.some(obj => obj[this.currentStatus] === null)
    },
    tabs() {
      return [
        {
          name: this.$t("adjustmentRequest"),
          systemName: "adjustmentRequest",
          isActive: this.modelTab.systemName === "adjustmentRequest",
        },
        {
          name: this.$t("addressProgramOutletInfo"),
          systemName: "addressProgramOutletInfo",
          isActive: this.modelTab.systemName === "addressProgramOutletInfo",
        },
      ];
    },
    tabs1() {
      return [
        {
          name: this.$t("generalInformationAboutTheOutlet"),
          systemName: "adjustmentReqgeneralInformationAboutTheOutletuest",
          isActive: this.modelTab.systemName === "adjustmentRequest",
        },
        {
          name: "",
          systemName: "adjustmentReqgeneralInformationAboutTheOutletuest",
          isHidden: true
        }
      ];
    },
    isProceeded() {
      return this.model && this.model.status === "adjustmentComplete";
    },
    isGrouped() {
      return this.model && this.model.type === "adjustmentGroupTT";
    },
    isAdjustmentTab() {
      return this.modelTab.systemName === "adjustmentRequest";
    },
    getAdjustmentEditedFields() {
      return this.adjustmentService.editedFields;
    },
    isDisabledReset() {
      return this.currentStatus === 'completed' || this.editedFields.every(obj => obj[this.currentStatus] === null);
    },
    isCancelDisabled() {
      return !this.checkAccessApproval && !this.checkAccessAcceptance;
    }
  }
};
</script>
<style lang="scss">
.adjustment-item-archive {
  .prospace-tabs__content {
    padding-left: 10px;
    padding-right: 10px;
    height: auto;

    .p-datatable-tbody {
      height: auto;
    }
    .p-datatable-wrapper {
      margin-right: 0;
      padding-right: 0;
    }
    .p-datatable {
      .p-datatable-tbody {
        min-width: 880px;
        > tr > td {
          padding-left: 5px;
        }
      }
      .p-datatable-thead {
        min-width: 880px;
        border-left: var(--prospace-ui-border);
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
      }
    }
    .p-selectable-row,
    .p-datatable .p-datatable-tbody > tr:not(.p-datatable-emptymessage) {
      width: calc(100% - 5px) !important;
      margin-left: auto !important;
      margin-right: auto !important;
    }

    .main-grid {
      height: 260px !important;
      overflow: hidden;
      border-top-right-radius: 5px;
      border-top-left-radius: 5px;
      .p-datatable .p-datatable-thead .p-column-resizer {
        transform: scale(1, 1);
      }
    }
  }
  .p-datatable-wrapper,
  &__view-adjustment .p-datatable .p-datatable-tbody {
    background-color: unset;
  }
  &__values {
    align-items: center !important;
    .prospace-text-block__top {
      font-weight: 400;
    }
    .prospace-text-block__bottom {
      font-size: 12px;
    }
  }
  &__action {
    width: auto !important;
    .prospace-h-layout {
      justify-content: flex-end !important;
    }
    .prospace-action-text {
      font-size: 12px;
      flex: 0 0 auto;
    }
    .prospace-icon + .prospace-action-text {
      flex: 0 0 calc(100% - 20px);
    }
    .prospace-icon {
      flex: 0 0 20px;
    }
  }
  &__status-cell {
    min-width: 384px;
  }
  &__acceptance-cell {
    padding-top: 0;
  }
  .p-datatable-tbody {
    .adjustment-item-archive__acceptance-cell {
      padding-top: 0 !important;
    }
    & > tr:not(.p-datatable-emptymessage) > td:last-child {
      padding-left: 10px;
    }
  }
}
.adjustment-item-archive__dots_itemMenu .prospace-icon {
  padding: 0 10px;
}
.adjustments-grid {
  &__select-btn {
    .prospace-select-button {
      .p-button {
        height: 26px !important;
        padding: 5px 7px;
      }
    }
    .prospace-select-button__icon-container {
      height: 16px !important;
      width: 16px !important;

      .prospace-icon {
        height: 20px !important;
        width: 20px !important;
        flex: 0 0 20px;
      }
    }
    .prospace-label {
      font-size: 12px !important;
    }
    .p-button.p-highlight:first-child {
      background: #FBE9E7 !important;
      border-color: #EE6D62 !important;
      .prospace-label {
        color: #EE6D62 !important;
      }
      .prospace-icon {
        background-color: #EE6D62 !important;
      }
    }
    .p-button.p-highlight:last-child {
      background: #E8F5E9 !important;
      border-color: #27AE60 !important;
      .prospace-label {
        color: #27AE60 !important;
      }
      .prospace-icon {
        background-color: #27AE60 !important;
      }
    }
  }
}
.adjustments-params {
  &__rows {
    & > .geo-row {
      grid-template-columns: 220px minmax(306px, 958px) !important;
      grid-template-areas: "left center";
      width: auto;
    }
    &--details {
      & > .geo-row {
        padding-top: 0;
      }
    }
  }
  &__left-block .prospace-text-block__bottom {
    color: var(--prospace-ui-icon-gray);
  }
}
</style>
